export function formatString(str: string): string {
    if (str.length <= 20) {
        return str;
    }

    const firstPart = str.slice(0, 10);
    const lastPart = str.slice(-11);
    return `${firstPart}...${lastPart}`;
}